import { useDispatch } from "react-redux"
import styled from "styled-components"
import { showModal } from "../../../../../features/modal/modalSlice"

const Container = styled.button`
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-lg);
    color: ${({theme}) => theme.mainTextColor};
    text-decoration: underline;
`

const YukSigortaTeklifBtn = () => {
  const dispatch = useDispatch()
  return (
    <Container onClick={() => dispatch(showModal("loadSigortaTeklif"))}>Uygun Fiyatlı Yük Sigortası Yaptırmak İster Misiniz?</Container>
  )
}

export default YukSigortaTeklifBtn